import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Formik, Field } from 'formik';
import RegularField from '../Forms/Fields/RegularField';
import * as AuthModule from '../../Modules/AuthModule';
import * as UserModule from '../../Modules/UserModule';
import * as Yup from 'yup';
import { RootState } from '../../Store/Reducers/RootReducer';
import Logo from 'Assets/Img/logo.jpeg';
import LogoEntire from 'Assets/Img/logo_entire.jpeg';
import { Selectors as AuthSelectors } from 'Modules/AuthModule';

type S = {};
type ConnectedP = {
  authorizedUser: AuthModule.Types.AuthorizedUserData;
};
type DispatchedP = {
  activateAccount: (data: any) => any;
};
class ActivateAccount extends React.Component<DispatchedP & ConnectedP, S> {
  constructor(props: ConnectedP & DispatchedP) {
    super(props);
  }

  public render() {
    if (!localStorage.getItem('token')) {
      const LoginSchema = Yup.object().shape({
        password: Yup.string().required('Pole wymagane').min(8, 'Minimum 8 znaków'),
        confirmation_password: Yup.string()
          .required('Pole wymagane')
          // eslint-disable-next-line func-names
          .test('passwords-match', 'Nieprawidłowe hasło', function (value) {
            return this.parent.password === value;
          }),
      });
      return (
        <div className="login">
          <div className="login__container">
            <div className="login__header">
              <div className="login__logo">
                <img src={Logo} alt="" />
              </div>
              <div className="login__logo-entire">
                <img src={LogoEntire} alt="" />
              </div>
            </div>
            <div className="login__form-container">
              <Formik
                initialValues={{ password: '', confirmation_password: '' }}
                validationSchema={LoginSchema}
                onSubmit={(values) => {
                  this.props.activateAccount({ activationToken: localStorage.getItem('activationToken'), password: values.password });
                }}>
                {({ handleSubmit, errors }) => (
                  <form onSubmit={handleSubmit} className="login__form">
                    <Field name="password" type="password" placeholder="Wpisz hasło" label="Hasło" component={RegularField} errors={errors} isAutoComplete={true} />
                    <Field name="confirmation_password" type="password" placeholder="Powtórz hasło" label="Powtórz Hasło" component={RegularField} errors={errors} isAutoComplete={true} />
                    <button className="btn btn--default btn--login btn--center" type="submit">
                      Aktywuj konto
                    </button>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      );
    } else {
      return <Redirect to={'/dashboard'} />;
    }
  }
}

const mapDispatchToProps: DispatchedP = {
  activateAccount: (data: any) => UserModule.Actions.activateAccount(data),
};

function mapStateToProps(state: RootState): ConnectedP {
  return {
    authorizedUser: AuthSelectors.authorizedUser(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivateAccount);
